//
//

import {
    mapGetters, mapActions, mapMutations, mapState
} from "vuex";
import { uid } from "quasar";
import { CHECK_NAME_REGEX_STARTING_ALPHA_ONLY } from "@/assets/js/appConfig";
import { getDataModel } from "@/pages/main/views/DataModel/views/DataModel/DataModelHelpers";
import deleteS from "@/assets/images/Buttons/deleteS.svg";
import deleteHover from "@/assets/images/Buttons/deleteHover.svg";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default { name: "EditCatModal",
    components: {
        AQModal, AQInput, AQDropdown, AQButton, AQTooltip, AQDialog, AQCard
    },
    props: {
        isInEdit: { type: Boolean, default: false },
        tableData: { type: Array, default: () => [] }
    },

    data() {
        return {
            duplicateDataModelName: "",
            duplicateInDataModel: false,
            newCatalogName: "",
            showModal: true,
            columnsCopy: null,
            deleteIcon: deleteS,
            noNameFound: false,
            columns: [],
            description: "",
            deleteHover,
            deleteColumnIndex: null,
            invalidName: false,
            duplicatedNameWithInactiveCat: false,
            name: `${this.$t("catalogs.addNewCat.name")}`,
            descriptionTitle: `${this.$t("catalogs.addNewCat.description")}`,
            addBtn: `${this.$t("catalogs.addNewCat.addBtn")}`,
            foundColName: false,
            invalidColNameFound: false,
            nullColFound: false,
            readonly: true,
            validatePattern: new RegExp(CHECK_NAME_REGEX_STARTING_ALPHA_ONLY),
            parentClassArray: [],
            descriptionCopy: "",
            newCatNameCopy: "",
            warningDialog: false
        };
    },
    computed: {
        ...mapGetters("catalogs", [
            "items",
            "selectedCatalogName",
            "temporaryColumnsCache",
            "selectedCatalogData",
            "inEditCatalogColumns",
            "columnDataTypesDDL",
            "existingCatalogsAsList",
            "selectedCat"
        ]),
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("catalogs", ["getMasterId", "getCommitId"]),
        ...mapState("main", ["interfaceDirty"]),
        catalogOpts() {
            return [...this.columnDataTypesDDL];
        },
        computedErrorName() {
            return this.invalidName || this.noNameFound || this.duplicatedNameWithInactiveCat || this.duplicateInDataModel;
        },
        computedNewCatalogName: {
            get() {
                return this.newCatalogName;
            },
            set(newName) {
                this.newCatalogName = newName.charAt(0).toUpperCase() + newName.slice(1);
            }
        },
        btnDisabled() {
            return this.duplicateInDataModel || this.duplicatedNameWithInactiveCat || this.foundColName
            || this.invalidName || this.noNameFound || this.invalidColNameFound || this.nullColFound || (!this.isInEdit && !this.newCatalogName)
            || (this.isInEdit && !this.isDirty());
        },
        hasSave() {
            return this.isInEdit ? { label: this.$t("generic.done"), disabled: this.btnDisabled }
                : { label: this.$t("generic.add"), disabled: this.btnDisabled };
        },
        titleModal() {
            return this.isInEdit ? `${this.$t("catalogs.editCat")}` : `${this.$t("catalogs.addCat")}`;
        },
        errorLabel() {
            let error = "";
            if (this.duplicateInDataModel) {
                error = `${this.$t("dataModel.modal.duplicateInDataModel", { name: this.duplicateDataModelName })}`;
            } else if (this.duplicatedNameWithInactiveCat) {
                error = `${this.$t("catalogs.addNewCat.duplicatedNameWithInactiveCat")}`;
            } else if (this.foundColName) {
                error = `${this.$t("catalogs.addNewCat.duplicatedColumn")}`;
            } else if (this.invalidName) {
                error = `${this.$t("catalogs.addNewCat.errorDuplicatedName", { name: this.newCatalogName })}`;
            } else if (this.noNameFound || this.invalidColNameFound) {
                error = `${this.$t("catalogs.addNewCat.noCatalogNameError")}`;
            } else if (this.nullColFound) {
                error = `${this.$t("catalogs.addNewCat.nullColumn")}`;
            }
            return error;
        }

    },
    watch: {
        newCatalogName() {
            let found = false;
            this.invalidName = false;
            this.invalidColNameFound = false;
            this.nullColFound = false;
            this.duplicatedNameWithInactiveCat = false;
            const nameToCheck = this.newCatalogName.charAt(0).toUpperCase() + this.newCatalogName.slice(1);
            this.existingCatalogsAsList.forEach(el => {
                if (!el.removed && nameToCheck === el.label) {
                    this.invalidName = true;
                    found = true;
                }
            });
            if (!found) {
                this.invalidName = false;
            }
            if (this.parentClassArray && this.parentClassArray.length) {
                let found2 = false;
                this.parentClassArray.forEach(elem => {
                    if (this.newCatalogName === elem.name) {
                        found2 = true;
                        this.duplicateInDataModel = true;
                        this.duplicateDataModelName = elem.name;
                    } else if (!found2) {
                        this.duplicateInDataModel = false;
                    }
                });
            }
        }

    },
    created() {
        this.description = this.isInEdit ? this.selectedCat.description : "";
    },

    mounted() {
        getDataModel().then(this.setGeneralModelDef);
        const stateColumnsCopy = Object.assign([], this.inEditCatalogColumns.filter(item => item.name !== "deleteColumn"));
        const filteredColumns = this.temporaryColumnsCache.filter(item => item.name !== "deleteColumn");
        this.$store.commit("catalogs/setTemporaryColumnsCache", filteredColumns);
        this.columns = filteredColumns.map((col, index) => {
            stateColumnsCopy[index].uuid = col.uuid;
            return { ...stateColumnsCopy[index] };
        });
        this.selectedCatalogNameCopy = this.selectedCatalogName;
        this.descriptionCopy = this.description;
        this.newCatNameCopy = this.computedNewCatalogName;
    },
    activated() {
        getDataModel().then(this.setGeneralModelDef);
    },
    methods: {
        ...mapActions("catalogs", ["getTableFormatFromNewCatalog", "getTableDetails"]),
        ...mapActions("apps", ["updateProcessInstance"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapMutations("catalogs", ["setTableDetails"]),
        compTypeColVal(type) {
            return type;
        },
        setGeneralModelDef(reqResponse) {
            this.parentClassArray = JSON.parse(
                JSON.stringify(reqResponse.data.modelClasses)
            );
        },
        modalClosed() {
            this.$emit("modalClosed");
        },
        checkIfNewCol(column) {
            return (this.columns.some(col => col.uuid === column.uuid));
        },
        columnName(colName, col) {
            if (!col.default) {
                col.name = colName;
            }
            this.checkDuplicatedCol();
            if (!this.foundColName) {
                this.checkAlphaColName();
            }
            if (!this.foundColName && !this.invalidColNameFound) {
                this.checkNullCol();
            }
        },
        showDeleteIcon(index) {
            this.deleteColumnIndex = index;
        },
        hideDeleteIcon() {
            this.deleteColumnIndex = null;
        },
        addCol() {
            if (!this.foundColName) {
                this.checkAlphaColName();
                if (!this.invalidColNameFound) {
                    this.nullColFound = true;
                    this.$store.commit("catalogs/addTemporaryColumn", {
                        type: "String",
                        name: null
                    });
                }
            }
        },
        deleteCol(item) {
            this.temporaryColumnsCache.splice(this.temporaryColumnsCache.indexOf(item), 1);
            this.foundColName = false;
            this.checkNullCol();
        },
        checkDuplicatedCol() {
            this.foundColName = false;
            for (let i = 0; i < this.temporaryColumnsCache.length - 1; i++) {
                for (let j = i + 1; j < this.temporaryColumnsCache.length; j++) {
                    if (this.temporaryColumnsCache[i].name && this.temporaryColumnsCache[j].name) {
                        if (this.temporaryColumnsCache[i].name.toLowerCase() === this.temporaryColumnsCache[j].name.toLowerCase()) {
                            this.temporaryColumnsCache[i].error = true;
                            this.temporaryColumnsCache[j].error = true;
                            this.foundColName = true;
                        } else {
                            this.temporaryColumnsCache[i].error = false;
                        }
                    }
                }
                if (this.foundColName) {
                    break;
                }
            }
        },
        saveDescription(val) {
            const descriptionPayload = {
                newDescription: val,
                selectedCatName: this.selectedCatalogName
            };
            this.$store.commit("catalogs/modifyDescription", descriptionPayload);
            this.selectedCat.description = val;
        },
        actionsDlg($event) {
            if ($event === "primary") {
                this.checkDuplicatedCol();
                if (!this.foundColName) {
                    if (!this.nullColFound) {
                        this.checkAlphaColName();
                    }
                }
                if (this.isInEdit) {
                    if (this.foundColName || this.invalidColNameFound || this.nullColFound) { return; }
                    this.saveDescription(this.description);
                    this.saveEditChanges();
                    this.showModal = false;
                    this.$store.commit("main/setInterfaceDirty", true);
                    this.$emit("modalClosed");
                } else {
                    this.checkValidation(this.newCatalogName);
                    if (this.noNameFound || this.foundColName || this.invalidColNameFound || this.nullColFound) { return; }
                    if (this.newCatalogName) {
                        if (this.existingCatalogsAsList.findIndex(dataType => (dataType.label === this.newCatalogName && !dataType.removed)) !== -1) {
                            this.invalidName = true;
                        } else if (this.existingCatalogsAsList.findIndex(dataType => (dataType.removed && dataType.label === this.newCatalogName)) !== -1) {
                            this.duplicatedNameWithInactiveCat = true;
                        } else {
                            this.saveDescription(this.description);
                            this.$store.commit("catalogs/setCatalogsAlreadySaved", false);
                            this.addCatalog();
                            this.showModal = false;
                            this.$emit("modalClosed");
                            this.$store.commit("catalogs/setColumns", []);
                            this.$store.commit("catalogs/setSelectedCatalogData", []);
                            const lastAddedCatalog = this.items[this.items.length - 1];
                            this.getTableFormatFromNewCatalog({
                                lastAddedCatalog,
                                dataTypes: this.columnDataTypesDDL
                            }).then(columns => {
                                this.$store.commit("catalogs/setColumns", columns);
                                // las asa momentan
                                // this.$store.commit("catalogs/setSelectedCatalogData", []);
                            });
                        }
                    } else {
                        this.noNameFound = true;
                    }
                }
            } else if ($event === "close") {
                if (this.isDirty()) {
                    this.warningDialog = true;
                } else {
                    this.showModal = false;
                    this.$emit("modalClosed");
                }
            }
        },
        checkValidation(val) {
            this.noNameFound = val && !this.validatePattern.test(val);
        },
        checkAlphaColName() {
            this.invalidColNameFound = false;
            for (let i = 0; i < this.temporaryColumnsCache.length; i++) {
                if (!this.temporaryColumnsCache[i].name || !this.validatePattern.test(this.temporaryColumnsCache[i].name)) {
                    this.invalidColNameFound = true;
                    this.temporaryColumnsCache[i].error = true;
                } else {
                    this.temporaryColumnsCache[i].error = false;
                }
            }
        },
        checkNullCol() {
            this.nullColFound = false;
            for (let i = 0; i < this.temporaryColumnsCache.length; i++) {
                if (!this.temporaryColumnsCache[i].name) {
                    this.temporaryColumnsCache[i].error = true;
                    this.nullColFound = true;
                } else {
                    this.temporaryColumnsCache[i].error = false;
                }
            }
        },
        defaultColTypeVal(val) {
            let returnType;
            if (val && val.length) {
                if (typeof val === "object") {
                    returnType = val[0].value;
                } else {
                    returnType = val;
                }
            }
            return returnType;
        },
        addCatalog() {
            const catObj = {
                fields: this.temporaryColumnsCache.map(col => {
                    col.isExstCat = !(
                        this.columnDataTypesDDL.findIndex(dataType => dataType.value === col.type[0].value) !== -1
                    );
                    return col;
                }),
                name: this.newCatalogName.charAt(0).toUpperCase() + this.newCatalogName.slice(1),
                id: uid(),
                data: [],
                description: this.description,
                commitId: this.getCommitId,
                masterId: this.getMasterId,
                applicationId: this.currentApp.id
            };
            this.$store.commit("catalogs/addCatalog", catObj);
            this.$root.$emit("newCatalogAdded", catObj.id);
            const dataForDisplay = {
                commitId: catObj.commitId,
                id: catObj.id,
                masterId: catObj.masterId,
                status: true,
                warning: ""
            };
            this.$root.$emit("displayCatalog", dataForDisplay);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$store.commit("catalogs/setMasterId", catObj.masterId);
            this.$store.commit("catalogs/setCommitId", catObj.commitId);
        },
        saveEditChanges() {
            const deletedColumns = [];
            const modifiedColumnNames = [];
            const modifiedTypes = [];
            const newColumns = [];
            for (let i = 0; i < this.columns.length; i++) {
                const initialCol = this.columns[i];
                const cache = this.temporaryColumnsCache.find(
                    col => col.uuid === initialCol.uuid
                );
                if (!cache) {
                    deletedColumns.push({ uuid: initialCol.uuid, name: initialCol.name });
                } else {
                    if (cache.type !== initialCol.type) {
                        modifiedTypes.push({
                            colCode: initialCol.uuid,
                            oldValue: initialCol.type,
                            newValue: cache.type
                        });
                    }
                    if (cache.name !== initialCol.name) {
                        modifiedColumnNames.push({
                            colCode: initialCol.uuid,
                            oldValue: initialCol.name,
                            newValue: cache.name
                        });
                    }
                }
            }
            const reducedToCodes = this.columns.map(oldcol => oldcol.uuid);

            newColumns.push(...this.temporaryColumnsCache.filter(col => reducedToCodes.indexOf(col.uuid) === -1));
            const copyOfTableData = [...this.tableData];
            for (let i = 0; i < copyOfTableData.length; i++) {
                deletedColumns.forEach(col => {
                    this.columns.forEach(colDetails => {
                        if (col.uuid === colDetails.uuid) {
                            delete copyOfTableData[i].columns[colDetails.name];
                        }
                    });
                });
            }
            if (newColumns && newColumns.length > 0) {
                this.$store.commit("catalogs/addColumnsToCatalog", {
                    columns: newColumns,
                    catName: this.selectedCatalogName
                });
            }
            if (deletedColumns && deletedColumns.length > 0) {
                this.$store.commit("catalogs/removeColumnsFromCatalog", {
                    columns: deletedColumns.map(column => column.name),
                    catName: this.selectedCatalogName
                });
            }
            this.$store.commit("catalogs/setUpdatedCatalogData", this.selectedCatalogData);
            const columnsToSet = [];
            for (let i = 0; i < this.temporaryColumnsCache.length; i++) {
                columnsToSet.push({
                    name: this.temporaryColumnsCache[i].name,
                    required: true,
                    label: this.temporaryColumnsCache[i].name,
                    align: "left",
                    field: this.temporaryColumnsCache[i].name,
                    sortable: true,
                    classes: "my-class",
                    style: "",
                    catId: this.catId,
                    isNewRow: this.isNewRow,
                    isExstCat:
            this.columnDataTypesDDL.findIndex(elem => elem.value === this.temporaryColumnsCache[i].type) === -1,
                    type: this.temporaryColumnsCache[i].type
                });
            }
            this.columns = columnsToSet;
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$store.commit("catalogs/setMasterId", this.getMasterId);
            this.$store.commit("catalogs/setCommitId", this.getCommitId);
            this.$store.commit("catalogs/setFieldsSelectedCat", columnsToSet);
            const copyOfSelected = { ...this.selectedCatalogData };
            const formattedFields = [];
            this.columns.forEach(col => {
                formattedFields.push({
                    name: col.name,
                    type: col.type
                });
            });
            copyOfSelected.fields = formattedFields;
            copyOfSelected.data = copyOfTableData;
            copyOfSelected.active = true;
            this.setTableDetails({ data: copyOfSelected });
            this.$root.$emit("updatedCatalog");
        },
        closeWithoutSaving() {
            this.warningDialog = false;
            this.showModal = false;
            this.$emit("modalClosed");
        },
        isDirty() {
            return this.dirtyColumns() || (this.newCatNameCopy !== this.computedNewCatalogName) || (this.descriptionCopy !== this.description);
        },
        dirtyColumns() {
            let dirtyColumns = false;
            if (this.temporaryColumnsCache.length === this.columns.length && this.temporaryColumnsCache.length > 2) {
                for (let i = 2; i < this.temporaryColumnsCache.length; i++) {
                    dirtyColumns = JSON.stringify(this.temporaryColumnsCache[i]) !== JSON.stringify(this.columns[i]);
                }
            } else if (this.temporaryColumnsCache.length !== this.columns.length) {
                dirtyColumns = true;
            }
            return dirtyColumns;
        }

    } };

